<template>
  <sw-modal :open="$attrs.open" @close="$emit('close')">
    <sw-panel class="modal-color" v-if="getColorList[currentPalette]">
      <div class="flex center-y">
        <span class="color-item mr-5" :style="{background: currentColor}"/>
        <input class="input-color" v-model="currentColor" @input="onChangeColor">
        <sw-button
          label="OK"
          class="action-button button-color-valid center"
          @click="$emit('close')"
        />
      </div>
      <div class="flex my-10 center-y modal-color-content">
        <span class="flex full modal-color-name">{{getColorList[currentPalette].label}}</span>
        <sw-button
          class="arrow-color-button ml-5 center"
          icon="arrow-left"
          font="fa"
          @click="prevPalette"
        />
        <sw-button
          class="arrow-color-button ml-5 center next-button-color"
          icon="arrow-right"
          font="fa"
          @click="nextPalette"
        />
      </div>
      <div class="color-wrapper">
        <div
          v-for="color in getColorList[currentPalette].colors"
          :key="getColorList[currentPalette].label+'-'+color"
          class="color-button-wrapper"
        >
          <span class="color-button" :style="{background: color}" @click="updateColor(color)"/>
          <sw-icon font="fa" icon="lock" class="locked-color" v-if="lockedColor"/>
        </div>
      </div>
    </sw-panel>
  </sw-modal>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { PAYMENT_INFO, EventBus } from '@/model/EventBus'
export default {
  name: 'ColorModal',
  components: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.currentColor = this.getCurrentColor
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      currentPalette: 0,
      currentColor: '#000'
    }
  },
  props: {},
  computed: {
    ...mapGetters(['getColorList', 'getCurrentColor', 'getCurrentFormat', 'getLimitations']),
    lockedColor() {
      if (this.getLimitations.colors !== -1 && this.currentPalette > this.getLimitations.colors) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions(['updateCurrentColor']),
    updateColor(color) {
      if (this.getLimitations.colors !== -1 && this.currentPalette > this.getLimitations.colors) {
        EventBus.$emit(PAYMENT_INFO, { type: 'infos', code: 'paymentContent', class: 'danger' })
        return
      }

      this.currentColor = color
      this.updateCurrentColor(color)
      this.$emit('changeColor', color)
      this.$emit('close')
    },
    nextPalette() {
      this.currentPalette++
      if (this.currentPalette >= this.getColorList.length) {
        this.currentPalette = 0
      }
    },
    prevPalette() {
      this.currentPalette--
      if (this.currentPalette < 0) {
        this.currentPalette = this.getColorList.length - 1
      }
    },
    onChangeColor() {
      this.updateCurrentColor(this.currentColor)
      this.$emit('changeColor', this.currentColor)
    }
  },
  watch: {}
}
</script>






// WEBPACK FOOTER //
// src/components/modal/ColorModal.vue